import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFinance } from '../store/slices/financeSlice';

export const useFinance = (startDate, endDate) => {
    const dispatch = useDispatch();
    const { loading } = useSelector(state => state.finance);
    const selectedBranch = useSelector(state => state.branches.selectedBranch);
    const selectedPlace = useSelector(state => state.branches.selectedPlace);
    const [financialData, setFinancialData] = useState({});

    const branchId = selectedBranch?.id;
    const placeId = selectedPlace?.id;

    const load = useCallback(async () => {
        if (!startDate || !endDate || !branchId) {
            setFinancialData({});
            return;
        }

        try {
            const result = await dispatch(getFinance({
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD'),
                branchId,
                placeId
            })).unwrap();
            setFinancialData(result || {});
        } catch (error) {
            console.error('Finance verisi alınırken hata:', error);
            setFinancialData({});
        }
    }, [dispatch, startDate, endDate, branchId, placeId]);

    useEffect(() => {
        load();
    }, [load]);

    return {
        financialData,
        loading,
        refetchFinance: load
    };
};
